import Vue from 'vue'

import * as ajaxService from '../api/api-service'
import common from './common.js'
import clipboard from 'clipboard'

Vue.prototype.$http = ajaxService
Vue.prototype.$common = common
Vue.prototype.$eventBus = new Vue()
Vue.prototype.clipboard = clipboard
